import React from "react";
import { getImage } from "../../helpers";
import { formatHumansBs } from "../../helpers/formatHuman";
import { useEffect } from "react";
import { useState } from "react";

const CartItemTable = ({ item, esUltimo, incrementar, decrementar, eliminarItem }) => {
    const [cantidadProduct, setCantidadProduct] = useState( item.cantidad );

    const onValueChanged = (value) => {
        let newCantidad = cantidadProduct + value;
        if (newCantidad < 1) return;
        if( value < 0 ) {
            decrementar( newCantidad, item.idprod );
        } else {
            incrementar( newCantidad, item.idprod );
        }
        setCantidadProduct( newCantidad );
    };
    return (
        <tr
            className={`bg-white ${
                !esUltimo ? "border-b" : ""
            } border-gray-200`}
        >
            <td className="px-6 py-4 font-medium text-gray-900">
                <div className="flex flex-col lg:flex-row items-center gap-2">
                    <img
                        src={getImage(item.imagen)}
                        alt="Propiedad imagen"
                        className="object-cover h-auto w-16"
                    />
                    <span className="text-xs lg:text-sm break-words font-semibold">
                        {item.nombrep}
                    </span>
                </div>
            </td>
            <td className="px-6 py-4 text-center font-semibold">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <span className="rounded-full cursor-pointer font-bold py-1 px-4 bg-gray-200" onClick={ () => onValueChanged(+1) }>
                            +
                        </span>
                        <span>{ cantidadProduct }</span>
                        <span className="rounded-full cursor-pointer font-bold py-1 px-4 bg-gray-400" onClick={ () => onValueChanged(-1) }>
                            -
                        </span>
                    </div>
                </div>
            </td>
            <td className="px-6 py-4 font-semibold">
                {formatHumansBs(item.precio)}
            </td>
            <td className="px-6 py-4 text-center">
                <span
                    onClick={ () => eliminarItem( item.idprod ) }
                    className="font-medium text-red-600  hover:underline cursor-pointer"
                    title="Eliminar"
                >
                    <i className="fa fa-trash"></i>
                </span>
            </td>
        </tr>
    );
};

export default CartItemTable;
